// Skill meter: correct-outcome % drives a tiered progress bar,
// deliberately scaled to a tight 40-65% window rather than 0-100% — real
// player skill differences cluster in that band, so a 0-100 scale would make
// everyone look like they're barely off the floor.
export const SKILL_METER_BAR_FLOOR_PCT = 40
export const SKILL_METER_BAR_CAP_PCT = 65

/**
 * The "always pick the home team" reference the meter's pin marks.
 *
 * A fixed fact about football, not a statistic about this app's data: across a full season the
 * home side wins roughly 47% of the time (177 of 380 = 46.58% in the reference season — see
 * `computeHomePickBaselinePct`'s full-season test in season.test.ts). The pin therefore sits in
 * the same place on gameweek 1 and gameweek 38.
 *
 * Do not recompute this from the season store. It was derived that way twice and was wrong both
 * times: read at module load it answered 0, because the store is empty until loadSeasonData
 * resolves; read at render it answered a running average, because /results is finished-only
 * and the denominator is "fixtures played so far", which sent the pin to the bar's right edge for
 * the opening third of a simulated season.
 */
export const HOME_PICK_BASELINE_PCT = 47

/** Maps a real correct-outcome % onto the bar's 40-65% visual scale, clamped
 * at both ends so a sub-40% or 65%+ value still renders at the bar's 0%/100%
 * bound rather than overflowing or vanishing. */
export function scaleToSkillMeterBar(pct: number): number {
  const clamped = Math.min(
    Math.max(pct, SKILL_METER_BAR_FLOOR_PCT),
    SKILL_METER_BAR_CAP_PCT
  )
  return (
    ((clamped - SKILL_METER_BAR_FLOOR_PCT) /
      (SKILL_METER_BAR_CAP_PCT - SKILL_METER_BAR_FLOOR_PCT)) *
    100
  )
}
